export enum PaymentTermStatus {
	SETTLED = 'S',
	UNSETTLED = 'U',
	PARTIALLY_SETTLED = 'P',
	OVERSETTLED = 'O',
}

export enum PaymentSource {
	MANUAL = 'MA',
	AUTOMATIC = 'AU',
}

export enum PaymentStatus {
	IN_PROGRESS = 'PE',
	COMPLETED = 'CO',
	CANCELED = 'CA',
}

export enum PaymentStatusReservation {
	UNPAID = 'unpaid',
	PARTIALLY_PAID = 'partially_paid',
	FULLY_PAID = 'fully_paid',
	OVERPAID = 'overpaid',
}

export const paymentStatusMappings: {
	[key in PaymentStatusReservation]: string;
} = {
	[PaymentStatusReservation.UNPAID]: 'nieopłacona',
	[PaymentStatusReservation.PARTIALLY_PAID]: 'częściowo opłacona',
	[PaymentStatusReservation.FULLY_PAID]: 'opłacona',
	[PaymentStatusReservation.OVERPAID]: 'nadpłacona',
};
